import { render, staticRenderFns } from "./FormViewComponent.vue?vue&type=template&id=4fb38ac2&scoped=true"
import script from "./FormViewComponent.vue?vue&type=script&lang=js"
export * from "./FormViewComponent.vue?vue&type=script&lang=js"
import style0 from "./FormViewComponent.vue?vue&type=style&index=0&id=4fb38ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb38ac2",
  null
  
)

export default component.exports